if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('cart-recommendations')) {
            window.dispatchEvent(new Event('scroll'))
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }


const removePricing = () => {
  document.querySelectorAll('.product-info').forEach(productInfo => {
    if (productInfo.querySelector('.bss-lock-element')) {
      productInfo
        .querySelectorAll('.kaching-bundles__bar-pricing, .kaching-bundles__deal-bar-progressive-gift__label-crossed-out')
        .forEach(el => el.remove());
    }
  });
};

removePricing();

let removePricingScheduled = false;
const removePricingObserver = new MutationObserver(() => {
  if (removePricingScheduled) return;
  removePricingScheduled = true;
  requestAnimationFrame(() => {
    removePricingScheduled = false;
    removePricing();
  });
});

removePricingObserver.observe(document.body, {
  childList: true,
  subtree: true
});